/**
 * ForYouQuestionView.js
 *
 * Clean layout:
 * - Single rounded card container
 * - Left PNG inside card
 * - Center content
 * - (Optional) Right PNG slot inside card
 *
 * No additional UI elements added.
 */

import rightImg from "../../../assets/Proposal.png";
import forYou from "../../../assets/foryou.JPG";

export default function ForYouQuestionView({
    yesScale,
    noScale,
    noClicks,
    yesDisabled,
    onYes,
    onNo,
})
{
    return (
        <div className="w-full flex items-center justify-center">
            <div className="w-3/4 rounded-3xl bg-white/70 backdrop-blur border border-rose-100 shadow-xl p-6 sm:p-8">
                
                <div className="flex items-center justify-between">
                    {/* Center Content */}
                    <div className="flex-1 flex flex-col items-start text-left gap-4">
                        <div className="flex items-center gap-4">
                            <img
                                src={forYou}
                                alt=""
                                className="h-24 w-24 object-cover select-none rounded-full border-[1px] pointer-events-none"
                                draggable={false}
                            />

                            <div className="text-left">
                                <div className="text-sm font-semibold text-rose-400">
                                    Happy
                                </div>
                                <div className="text-5xl font-cursive font-semibold text-zinc-900">
                                    Valentine's Day
                                </div>
                                <div className="text-sm sm:text-xl font-semibold text-rose-400">
                                    Kitty ♥️
                                </div>
                            </div>
                        </div>

                        <div className="w-full flex items-stretch gap-6">

                            {/* LEFT SECTION */}
                            <div className="w-24 flex justify-center">
                                <div className="w-[1px] bg-black rounded-full" />
                            </div>

                            {/* RIGHT SECTION */}
                            <div className="flex-1">

                                <div className="mt-1">
                                    <h1 className="text-2xl sm:text-3xl font-bold text-zinc-900">
                                        Will you be my valentine?
                                    </h1>

                                    <p className="mt-2 text-sm sm:text-base text-zinc-600">
                                        I promise– <br/>
                                        • To keep the PJs to a minimum (no guarantees on the puns though), <br/>
                                        • Cuddles to be perfect, <br/>
                                        • Keeping my mouth shut (most of the times), <br/>
                                        • A life full of happiness. <br/>
                                        (And many other things I couldn't write)
                                    </p>

                                    {/* {noClicks > 0 && (
                                        <div className="mt-3 inline-flex items-center gap-2 text-xs text-rose-500 bg-rose-50 border border-rose-100 px-3 py-1 rounded-full">
                                            <span className="select-none">No attempts:</span>
                                            <span className="font-semibold">{noClicks}</span>
                                            <span className="select-none">😤</span>
                                        </div>
                                    )} */}
                                </div>

                                <div
                                    className="w-full mt-3 flex items-center"
                                    style={{ gap: `${0.5 + (noClicks * 0.5)}rem` }}
                                >
                                    <button
                                        type="button"
                                        disabled={yesDisabled}
                                        onClick={onYes}
                                        style={{ transform: `scale(${yesScale})` }}
                                        className={[
                                            "transition-transform duration-200",
                                            "rounded-2xl px-7 py-3",
                                            "bg-rose-500 text-white font-semibold",
                                            "shadow-lg shadow-rose-200",
                                            "hover:brightness-105 active:brightness-95",
                                            "focus:outline-none focus:ring-2 focus:ring-rose-300",
                                        ].join(" ")}
                                    >
                                        Yes 💘
                                    </button>

                                    <button
                                        type="button"
                                        onClick={onNo}
                                        style={{ transform: `scale(${noScale})` }}
                                        className={[
                                            "transition-transform duration-200",
                                            "rounded-2xl px-7 py-3",
                                            "bg-zinc-900 text-white font-semibold",
                                            "shadow-lg shadow-zinc-200",
                                            "hover:brightness-110 active:brightness-95",
                                            "focus:outline-none focus:ring-2 focus:ring-zinc-300",
                                        ].join(" ")}
                                    >
                                        No 🙃
                                    </button>
                                </div>

                                <div className="mt-4 text-xs text-black/40">
                                    Tip: The “No” button is… emotionally unstable.
                                </div>

                            </div>

                        </div>
                    </div>

                    {/* Optional Right PNG Slot */}
                    
                    <img
                        src={rightImg}
                        alt=""
                        className="h-96 object-contain select-none pointer-events-none"
                        draggable={false}
                    />
                   

                </div>
            </div>
        </div>
    );
}